(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["braxium-product-main"]) return;
  try {
    
  document.querySelectorAll('[data-brx-product]').forEach((section) => {
    const track = section.querySelector('[data-brx-track]');
    const slides = section.querySelectorAll('[data-brx-slide]');
    const thumbs = section.querySelectorAll('[data-brx-thumb]');
    const current = section.querySelector('[data-brx-current]');
    if (!track || slides.length < 2) return;
    let index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === index); thumb.setAttribute('aria-pressed', String(i === index)); });
      if (current) current.textContent = index + 1;
      const selected = thumbs[index];
      const rail = selected?.parentElement;
      if (rail) rail.scrollTo({ left: rail.scrollLeft + selected.getBoundingClientRect().left - rail.getBoundingClientRect().left - (rail.clientWidth - selected.offsetWidth) / 2, behavior: 'instant' });
    };
    section.querySelector('[data-brx-prev]')?.addEventListener('click', () => show(index - 1));
    section.querySelector('[data-brx-next]')?.addEventListener('click', () => show(index + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.brxThumb))));
    show(0);
    let startX = 0;
    track.addEventListener('pointerdown', (event) => { startX = event.clientX; });
    track.addEventListener('pointerup', (event) => {
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 50) show(distance < 0 ? index + 1 : index - 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braxium-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
 const reveal = () => {const d=document.getElementById('brx-review-form');if(d && (location.hash === '#brx-review-form' || location.hash === '#brx-review-contact' || new URLSearchParams(location.search).has('contact_posted')))d.open=true;};
 document.addEventListener('click',e=>{if(e.target.closest('a[href="#brx-review-form"]')){const d=document.getElementById('brx-review-form');if(d)d.open=true;}});
 window.addEventListener('hashchange',reveal);reveal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braxium-v2-footer"]) return;
  try {
    
document.querySelectorAll('[data-bf-cookies]').forEach(a=>a.addEventListener('click',e=>{if(window.privacyBanner&&window.privacyBanner.showPreferences){e.preventDefault();window.privacyBanner.showPreferences();}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braxium-v2-header"]) return;
  try {
    
document.querySelectorAll('.bn-mobile').forEach(menu=>{menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>menu.open=false));menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braxium-v2-home"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{document.querySelectorAll('[data-bh-root]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');const video=root.querySelector('[data-bh-video]');if(video){let visible=true;const playback=()=>{if(reduced.matches||document.hidden||!visible){video.pause();return;}video.play().catch(()=>{});};const source=()=>{const mobile=root.clientWidth<750;const src=mobile?video.dataset.mobile:video.dataset.desktop;video.removeAttribute('poster');if(reduced.matches){video.pause();video.removeAttribute('src');video.load();return;}if(video.getAttribute('src')!==src){video.src=src;video.load();}video.muted=true;playback();};new ResizeObserver(source).observe(root);new IntersectionObserver(e=>{visible=e[0].isIntersecting;playback();},{threshold:.05}).observe(video);document.addEventListener('visibilitychange',playback);reduced.addEventListener('change',source);source();}const reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-revealed');reveal.unobserve(e.target);}}),{threshold:.08});if(!reduced.matches)root.querySelectorAll('[data-bh-reveal]').forEach(e=>{e.classList.add('is-ready');reveal.observe(e);});const track=root.querySelector('[data-bh-track]');if(track){const slides=[...track.children],count=root.querySelector('[data-bh-count]');let index=0;const move=delta=>{index=(index+delta+slides.length)%slides.length;track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:reduced.matches?'instant':'smooth'});};root.querySelector('[data-bh-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-bh-next]').addEventListener('click',()=>move(1));track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});let frame;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const width=slides[1].offsetLeft-slides[0].offsetLeft;index=Math.round(track.scrollLeft/width);count.textContent=String(index+1).padStart(2,'0')+' / 04';});},{passive:true});}});};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);document.querySelectorAll('[data-bh-width]').forEach(b=>b.addEventListener('click',()=>{document.querySelectorAll('.bh,.bn,.bf').forEach(e=>e.style.width=b.dataset.bhWidth==='full'?'100%':b.dataset.bhWidth+'px');}));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braxium-v2-product"] && !Shopify.designMode) return;
  try {
    

(()=>{
const init=(scope=document)=>scope.querySelectorAll('[data-bv-root]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const hero=root.querySelector('[data-bv-hero]');
 if(hero){let shown=true,mode='';const media=()=>{const next=root.clientWidth<750?'mobile':'desktop';hero.removeAttribute('poster');if(reduced.matches){hero.pause();if(hero.hasAttribute('src')){hero.removeAttribute('src');hero.load();mode='';}return;}if(next!==mode){mode=next;hero.pause();hero.src=next==='mobile'?hero.dataset.mobile:hero.dataset.desktop;hero.load();}hero.muted=true;if(!shown||document.hidden)hero.pause();else hero.play().catch(()=>{});};new ResizeObserver(media).observe(root);new IntersectionObserver(e=>{shown=e[0].isIntersecting;media();},{threshold:.05}).observe(hero);reduced.addEventListener('change',media);document.addEventListener('visibilitychange',media);media();}
 const gallery=root.querySelector('[data-bv-gallery]');if(gallery){const track=gallery.querySelector('.bv-gallery-track');const slides=[...gallery.querySelectorAll('[data-bv-slide]')];const thumbs=[...gallery.querySelectorAll('[data-bv-thumb]')];let index=0;const show=(n)=>{index=(n+slides.length)%slides.length;track.style.transform=`translateX(-${index*100}%)`;gallery.querySelector('[data-bv-count]').textContent=`${index+1} / ${slides.length}`;thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));const rail=thumbs[index].parentElement;rail.scrollTo({left:rail.scrollLeft+thumbs[index].getBoundingClientRect().left-rail.getBoundingClientRect().left-(rail.clientWidth-thumbs[index].clientWidth)/2,behavior:'instant'});};gallery.querySelector('[data-bv-prev]').addEventListener('click',()=>show(index-1));gallery.querySelector('[data-bv-next]').addEventListener('click',()=>show(index+1));thumbs.forEach((b,i)=>b.addEventListener('click',()=>show(i)));track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1));}});let start=null;track.addEventListener('pointerdown',e=>{start={x:e.clientX,y:e.clientY};});track.addEventListener('pointerup',e=>{if(start&&Math.abs(e.clientX-start.x)>45&&Math.abs(e.clientX-start.x)>Math.abs(e.clientY-start.y))show(index+(e.clientX<start.x?1:-1));start=null;});track.addEventListener('pointercancel',()=>start=null);}
 root.querySelectorAll('[data-b2-carousel]').forEach(carousel=>{const rail=carousel.querySelector('.b2-profiles'),slides=[...rail.children],count=carousel.querySelector('[data-b2-count]');let index=0;const go=n=>{index=Math.max(0,Math.min(slides.length-1,n));rail.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:reduced.matches?'instant':'smooth'});};carousel.querySelector('[data-b2-prev]').addEventListener('click',()=>go(index-1));carousel.querySelector('[data-b2-next]').addEventListener('click',()=>go(index+1));rail.addEventListener('scroll',()=>{index=slides.reduce((best,s,i)=>Math.abs(s.offsetLeft-slides[0].offsetLeft-rail.scrollLeft)<Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-rail.scrollLeft)?i:best,0);count.textContent=String(index+1).padStart(2,'0')+' / 04';carousel.querySelector('[data-b2-prev]').disabled=index===0;carousel.querySelector('[data-b2-next]').disabled=index===slides.length-1;},{passive:true});rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});carousel.querySelector('[data-b2-prev]').disabled=true;});
 const sticky=document.querySelector('[data-bv-sticky]');const form=root.querySelector('.bv-form');
 root.querySelectorAll('[data-bv-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=form.querySelector('[name=quantity]');if(button.dataset.bvQuantity==='1')input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}));
 const variantSelect=root.querySelector('[data-bv-variant]');if(variantSelect)variantSelect.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('variant',variantSelect.value);url.hash='bv-buy';location.assign(url.toString());});
 if(sticky&&form){let frame;const update=()=>{const rect=form.getBoundingClientRect();const mobile=root.clientWidth<750;const blocked=[...document.querySelectorAll('dialog[open],.drawer.active,#shopify-pc__banner')].some(el=>el.getBoundingClientRect().height>0&&getComputedStyle(el).visibility!=='hidden');const visible=mobile&&rect.bottom<0&&!blocked;sticky.classList.toggle('is-visible',visible);sticky.inert=!visible;sticky.setAttribute('aria-hidden',String(!visible));};new IntersectionObserver(update,{threshold:[0,1]}).observe(form);window.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});new ResizeObserver(update).observe(root);new MutationObserver(update).observe(document.body,{childList:true,subtree:true});update();}

});init();document.addEventListener('shopify:section:load',e=>init(e.target));
document.addEventListener('click',e=>{if(e.target.closest('a[href="#brx-details"]')){const details=document.getElementById('brx-details');if(details)details.open=true;}});
document.querySelectorAll('[data-bv-width]').forEach(button=>button.addEventListener('click',()=>{const width=button.dataset.bvWidth;document.querySelectorAll('.bv,.bn,.bf').forEach(root=>{root.style.width=width==='full'?'100%':width+'px';root.style.setProperty('--bv-test-width',width==='full'?'100%':width+'px');});const sticky=document.querySelector('[data-bv-sticky]');if(sticky){sticky.style.width=width==='full'?'100%':width+'px';sticky.classList.toggle('is-test-mobile',width!=='full'&&Number(width)<750);}}));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braxium-video-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = (scope = document) => scope.querySelectorAll('[data-brx-cinema]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const video = root.querySelector('video');
  const button = root.querySelector('.brx-cinema__pause');
  const stage = root.querySelector('.brx-cinema__stage');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused = false;
  let source = '';
  let visible = true;
  const labels = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; button.dataset.paused = String(video.paused); };
  const configure = () => {
   if (reduced.matches) {video.pause();video.classList.remove('is-playing');button.hidden = true;return;}
   const next = root.clientWidth <= 749 ? video.dataset.mobile : video.dataset.desktop;
   if (!next) return;
   if (next !== source) {video.classList.remove('is-playing');source = next;video.src = next;video.muted = true;video.load();}
   if (!userPaused && visible && !document.hidden) video.play().catch(() => {button.hidden = false;labels();});
  };
  video.addEventListener('playing', () => {video.classList.add('is-playing');button.hidden = false;labels();});
  video.addEventListener('pause',labels);
  video.addEventListener('error',() => {video.classList.remove('is-playing');button.hidden = true;});
  button.addEventListener('click',() => {userPaused = !video.paused;if(userPaused)video.pause();else video.play().catch(() => {});});
  new ResizeObserver(configure).observe(root);
  reduced.addEventListener('change',configure);
  new IntersectionObserver(entries => {visible = entries[0].isIntersecting;if(visible)configure();else video.pause();},{threshold:0}).observe(stage);
  document.addEventListener('visibilitychange',() => {if(document.hidden)video.pause();else configure();});
  configure();
 });
 initialize();
 document.addEventListener('shopify:section:load',event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
